import {isMobile} from '../../../../../commons/selectors/environment'
import {isCardsLayout, isListLayout, getComponentConfig} from '../../selectors/settings'
import {isMainTitleVisible} from '../../selectors/list-settings'
import {AppProps} from '../app/interfaces'
import {connect} from '../runtime-context/connect'
import {MainListTitle as Presentation} from './main-list-title'
import {MainListTitleStateProps} from './interfaces'

const mapRuntimeToContext = ({state}: AppProps): MainListTitleStateProps => {
  const componentConfig = getComponentConfig(state)

  return {
    listLayout: isListLayout(componentConfig),
    cardsLayout: isCardsLayout(componentConfig),
    mobile: isMobile(state),
    visible: isMainTitleVisible(state),
    settings: componentConfig.settings,
  }
}

export const MainListTitle = connect<{}, MainListTitleStateProps>(mapRuntimeToContext)(Presentation)
export * from './interfaces'
